// extracted by mini-css-extract-plugin
export default {"iot":"qing_ping_iot_iot__VXkhx"};